import moment from "moment";

export function GenerarSemana() {
  const semana = [];
  const hoy = moment();

  const diasHastaLunes = (8 - hoy.isoWeekday()) % 7 || 7;
  const proximoLunes = hoy.clone().add(diasHastaLunes, "days");

  for (let i = 0; i <= 4; i++) {
    semana.push({
      fecha: proximoLunes.clone().add(i, "days").format("YYYY-MM-DD"),
    });
  }

  return semana;
}

//console.log(GenerarSemana());
